import { AppState } from '@/vuex/store';
import customerImport, { CustomerImport } from '../../models/CustomerImport';

export default {
  SET_CUSTOMER_IMPORT: (state: AppState, customerImport: CustomerImport) => {
    state.customerState.customerImport = customerImport;  
  },
  RESET_CUSTOMER_IMPORT: (state: AppState) => {
    state.customerState.customerImport = JSON.parse(JSON.stringify(customerImport));
  },
};
